import { render, staticRenderFns } from "./MOHSelector.vue?vue&type=template&id=52a42cd1&"
import script from "./MOHSelector.vue?vue&type=script&lang=js&"
export * from "./MOHSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports